import {CoreDataLoaders, DataLoader, enumContainer, i18nContainer, PrefetchLoader} from '@wallaby-ui/core';
import {agensContainer} from '@wallaby-ui/document';

import AppConfig from './app_config';

// NOTE: fetch without auth
export const CoreDataConfig: CoreDataLoaders = {
  enums: [
    {
      id: 'wallaby-core',
      apiUrl: AppConfig.service.url.coreEnums,
      component: enumContainer.EnumLoader,
    },
    {
      id: 'haidi',
      apiUrl: AppConfig.service.url.haidiEnums,
      component: enumContainer.EnumLoader,
    },
  ],
  translations: [
    {
      id: 'wallaby-core',
      apiUrl: AppConfig.service.url.coreTranslations,
      component: i18nContainer.TranslationsLoader,
    },
    {
      id: 'haidi',
      apiUrl: AppConfig.service.url.haidiTranslations,
      component: i18nContainer.TranslationsLoader,
    },
  ],
};

// NOTE: fetch with auth
export const AppDataConfig: DataLoader[] = [
  {
    id: 'agensFilterData',
    apiUrl: AppConfig.service.url.pathogens,
    component: agensContainer.AgensLoader,
  },
  {
    id: 'snomed-current',
    apiUrl: AppConfig.service.url.snomedLabels,
    component: PrefetchLoader,
    useLocale: true,
  },
  {
    id: 'snomed-en',
    apiUrl: AppConfig.service.url.snomedLabels,
    component: PrefetchLoader,
    useLocale: 'en',
  },
];
